import { EB_ISKAN_MUELLIF } from "../constants/requestUrls";
import { getRequest } from "../request";

const ebIskanMuellifList = () => {
    return getRequest({url:EB_ISKAN_MUELLIF});
}

export default ebIskanMuellifList;